import { Box, Center, Divider, Flex } from '@hover/blueprint';
import React from 'react';

import { Skeleton } from 'src/shared/components/Skeleton/Skeleton';

import { PROJECT_DETAILS_PADDING } from './ProjectCardSection';

export const ProjectSkeleton = () => (
  <Center height="100%">
    <Box flexDirection="column" width="100%">
      <Skeleton
        borderRadius={0}
        height={{ base: '460px', tablet: '570px' }}
        width="100%"
      />
      <Box width="100%">
        <Flex
          align="flex-start"
          flexDirection="column"
          gap={200}
          padding={PROJECT_DETAILS_PADDING}
          width="100%"
        >
          <Divider mb={700} mt={600} />
          <Skeleton height={800} width="100%" />
        </Flex>
      </Box>
    </Box>
  </Center>
);
